module.exports = __webpack_public_path__ + "static/media/jmi.45a6ace7.png";